export function buildEnv({ TARGET, PHASE }, dataByTargetAndPhase) {
  const dataByPhase = dataByTargetAndPhase[TARGET];
  if (!dataByPhase) return { TARGET };

  const data = dataByPhase[PHASE];
  if (!data) return { TARGET, PHASE };

  return { TARGET, PHASE, ...data };
}
